import isEqual from "lodash/isEqual";
import $ from "jquery";
import classNames from "classnames";
import { observer } from "mobx-react";
import React, { Component } from "react";
import PropTypes from "prop-types";

import AttributeSelectionWidget from "./AttributeSelectionWidget";
import QuantityInput from "./QuantityInput";
import * as queryString from "query-string";
import { showCarousel } from "./VariantImageCarousel";

export default observer(
  class VariantPicker extends Component {
    static propTypes = {
      onAddToCheckoutError: PropTypes.func.isRequired,
      onAddToCheckoutSuccess: PropTypes.func.isRequired,
      store: PropTypes.object.isRequired,
      variantAttributes: PropTypes.array.isRequired,
      variants: PropTypes.array.isRequired
    };

    constructor(props) {
      super(props);
      const { variants } = this.props;

      const variant = variants.filter(
        v => !!Object.keys(v.attributes).length
      )[0];
      const params = queryString.parse(location.search);
      let selection = {};
      if (Object.keys(params).length) {
        Object.keys(params).some(name => {
          const valueName = params[name];
          const attribute = this.matchAttributeBySlug(name);
          const value = this.matchAttributeValueByName(attribute, valueName);
          if (attribute && value) {
            selection[attribute.pk] = value.pk.toString();
          }
        });
      }
      this.state = {
        checked: false,
        errors: {},
        quantity: 1,
        selection: selection,
        email: '',
        waitlistSuccess: false
      };
      this.matchVariantFromSelection();
    }

    // Show the correct carousel when variant is accessed via url params
    componentDidMount() {
      const matchedVariant = this.props.store.variant;

      // Always default to all images carousel
      let targetCarouselId = "carousel-all-product-images";

      // If a variant is selected, show the variant-specific carousel
      if (matchedVariant && matchedVariant.id) {
        targetCarouselId = `carousel-variant-${matchedVariant.id}`;
      }

      showCarousel(targetCarouselId);
    }

    checkVariantAvailability = () => {
      const { store } = this.props;
      return store.variant.availability;
    };

    handleAddToCheckout = () => {
      const {
        onAddToCheckoutSuccess,
        onAddToCheckoutError,
        store
      } = this.props;
      const { quantity } = this.state;
      if (quantity > 0 && !store.isEmpty) {
        const url = $('#variant-picker').data('action-checkout');
        $.ajax({
          url: url,
          method: "post",
          data: {
            quantity: quantity,
            variant: store.variant.id
          },
          success: () => {
            this.setState({ checked: true });
            setTimeout(() => {
              this.setState({ checked: false });
            }, 2000);
            onAddToCheckoutSuccess();
          },
          error: response => {
            onAddToCheckoutError(response);
          }
        });
        const pickerElement = document.getElementById("variant-picker");
        if (pickerElement) {
          pickerElement.dispatchEvent(
            new CustomEvent("pickerAddToCart", {
              detail: { variant: store.variant, quantity },
            })
          );
        }
      }
    };

    handleAttributeChange = (attrId, valueId) => {
      if (this.state.selection[attrId] === valueId) {
        return;
      }

      const selectedAttributeIndex = this.props.variantAttributes.findIndex(
        attribute => attribute.pk.toString() === attrId
      );
      const selection = {};
      this.props.variantAttributes.forEach((attribute, index) => {
        const attributeId = attribute.pk.toString();
        if (index < selectedAttributeIndex && this.state.selection[attributeId]) {
          selection[attributeId] = this.state.selection[attributeId];
        }
      });
      selection[attrId] = valueId;

      this.setState(
        {
          selection: selection
        },
        () => {
          this.matchVariantFromSelection();
          let params = {};
          Object.keys(this.state.selection).forEach(attrId => {
            const attribute = this.matchAttribute(attrId);
            const value = this.matchAttributeValue(
              attribute,
              this.state.selection[attrId]
            );
            if (attribute && value) {
              params[attribute.slug] = value.slug;
            }
          });
          history.replaceState(null, null, "?" + queryString.stringify(params));

          const matchedVariant = this.props.store.variant;

          // Always default to all images carousel
          let targetCarouselId = "carousel-all-product-images";

          // If a variant is selected, show the variant-specific carousel
          if (matchedVariant && matchedVariant.id) {
            targetCarouselId = `carousel-variant-${matchedVariant.id}`;
          }

          showCarousel(targetCarouselId);
        }
      );
    };

    getSelectionBeforeAttribute = attrId => {
      const selection = {};
      const attributeIndex = this.props.variantAttributes.findIndex(
        attribute => attribute.pk.toString() === attrId.toString()
      );
      this.props.variantAttributes.forEach((attribute, index) => {
        const attributeId = attribute.pk.toString();
        if (index < attributeIndex && this.state.selection[attributeId]) {
          selection[attributeId] = this.state.selection[attributeId];
        }
      });
      return selection;
    };

    isAttributeValueSelectable = (attrId, valueId) => {
      const selection = Object.assign(
        {},
        this.getSelectionBeforeAttribute(attrId),
        {
          [attrId.toString()]: valueId.toString()
        }
      );
      return this.props.variants.some(variant =>
        Object.keys(selection).every(
          attributeId => variant.attributes[attributeId] === selection[attributeId]
        )
      );
    };

    handleQuantityChange = event => {
      this.setState({ quantity: parseInt(event.target.value) });
    };

    handleEmailChange = event => {
      this.setState({ email: event.target.value });
    };

    onAddToWaitlistSuccess = () => {
      this.setState({
        waitlistSuccess: true
      });
      const $error = $(".product__waitlist__form-error");
      $error.attr("hidden", true);
    };

    handleWaitlistSubmit = (event) => {
      event.preventDefault();
      const { email } = this.state;
      const { store } = this.props;
      const url = $('#variant-picker').data('action-waitlist');
      if (email) {

        $.ajax({
          url: url,
          method: "POST",
          data: {
            email,
            variant: store.variant.id
          },
          success: (response) => {
            this.onAddToWaitlistSuccess();
          },
          error: (response) => {
            const errorText = $.parseJSON(response.responseText).error.email;
            const $error = $(".product__waitlist__form-error");
            $error.html(errorText);
            $error.attr("hidden", false);
          },
        });
      }
    };

    matchAttribute = id => {
      const { variantAttributes } = this.props;
      const match = variantAttributes.filter(
        attribute => attribute.pk.toString() === id
      );
      return match.length > 0 ? match[0] : null;
    };

    matchAttributeBySlug = slug => {
      const { variantAttributes } = this.props;
      const match = variantAttributes.filter(
        attribute => attribute.slug === slug
      );
      return match.length > 0 ? match[0] : null;
    };

    matchAttributeValue = (attribute, id) => {
      const match = attribute.values.filter(
        attribute => attribute.pk.toString() === id
      );
      return match.length > 0 ? match[0] : null;
    };

    matchAttributeValueByName = (attribute, name) => {
      const match = attribute
        ? attribute.values.filter(value => value.slug === name)
        : [];
      return match.length > 0 ? match[0] : null;
    };

    matchVariantFromSelection() {
      const { store, variants } = this.props;
      let matchedVariant = null;
      variants.forEach(variant => {
        if (isEqual(this.state.selection, variant.attributes)) {
          matchedVariant = variant;
        }
      });
      store.setVariant(matchedVariant);
    }

    render() {
      const { store, variantAttributes } = this.props;
      const { checked, errors, selection, quantity, email, waitlistSuccess } = this.state;
      const variantPublished = store.variant.published;
      const disableAddToCheckout =
        store.isEmpty || !this.checkVariantAvailability() || !variantPublished;
      const variantSelected = !store.isEmpty;
      const inPreorder = store.variant.preorder;
      const outOfStock = variantSelected && !store.variant.availability;
      const showUnpublishedAlert = variantSelected && !variantPublished;
      const showPreorderAlert = inPreorder &&  !outOfStock && variantPublished;
      const showOutOfStockAndWaitlist = variantSelected && outOfStock && variantPublished;
      const novaLink = store.variant.nova_link;
      const addToCheckoutBtnClasses = classNames({
        "btn btn-primary": true,
        "btn-checked": checked,
        disabled: disableAddToCheckout,
      });

      return (
        <div>
          {variantAttributes.map((attribute, i) => (
            <AttributeSelectionWidget
              attribute={attribute}
              handleChange={this.handleAttributeChange}
              isValueSelectable={this.isAttributeValueSelectable}
              key={i}
              selected={selection[attribute.pk]}
            />
          ))}
          <div className="clearfix">
          {(novaLink) ? (
            <p className="alert alert-warning">
              {pgettext("iPhone user suggestion", "Are you an iPhone user? Consider getting the ")}
              <a href={novaLink} onClick={() => gtag('event', 'nova_upsell', {context: "iphone"})}>BitBox02 Nova</a>
              {pgettext("iPhone user suggestion", " for iOS support instead.")}
            </p>
            ) : ""}
          {showUnpublishedAlert ? (
            <p className="alert alert-warning">
              {pgettext("Variant unpublished", "Unfortunately this variant is not available.")}
              <br />
              {pgettext("Variant unpublished", "Please change your selection.")}
            </p>
          ) : ""}
          {showPreorderAlert ? (
              store.variant.restock_date_text ? (
                <p className="alert alert-warning">
                  {pgettext("Preorder shipping textual", "Pre-order now. Expected to ship ")} {store.variant.restock_date_text}
                </p>
              ) : store.variant.restock_date_formatted ? (
                  <p className="alert alert-warning">
                    {pgettext("Backorder shipping date", "Item in high demand. Expected to ship around")} {store.variant.restock_date_formatted}
                  </p>
              ) : ""
            ) : ""}
            {/* Always show quantity input and button when no variant selected or when variant is in stock */}
            {(!variantSelected || !outOfStock) && (
              <>
                <QuantityInput
                  errors={errors.quantity}
                  handleChange={this.handleQuantityChange}
                  quantity={quantity}
                />
                <div className="form-group product__info__button">
                  <button
                    className={addToCheckoutBtnClasses}
                    onClick={this.handleAddToCheckout}
                    disabled={disableAddToCheckout}
                  >
                    {disableAddToCheckout
                    ? pgettext("Product details primary action", "Select a variant first")
                    : (checked
                  ? pgettext("Product details primary action", "Added")
                  : pgettext("Product details primary action", "Add to cart")
                )}
                  </button>
                </div>
              </>
            )}
          </div>
          {/* Only show out of stock message and waitlist form when a variant is selected and it's out of stock */}
          {showOutOfStockAndWaitlist && (
              <>
              <p className="alert alert-warning">{pgettext("Out of stock warning", "This item is out of stock.")}</p>
              <div>
              {waitlistSuccess ? (
                <p className="alert alert-success">{pgettext("Storefront waitlist signup message", "We will notify you via email once the selected item is back in stock.")}</p>
              ) : (
                <>
                <p><strong>{pgettext("Notify me when item is back in stock", "Notify me when the item is back in stock")}</strong></p>
                <form method="post" className="form-group" onSubmit={this.handleWaitlistSubmit}>
                  <div className="input-group">
                    <input
                      type="email"
                      name="email"
                      value={email}
                      onChange={this.handleEmailChange}
                      placeholder={pgettext("Enter your email", "Enter your email")}
                      required
                      className="form-control"
                    />
                    <div className="input-group-append">
                      <button type="submit" className="btn btn-primary" style={{ padding: '0 10px' }}>
                        {pgettext("Submit", "Submit")}
                      </button>
                    </div>
                  </div>
                </form>
                </>
              )}
              </div>
              </>
          )}
        </div>
      );
    }
  }
);
